import { toJS } from 'mobx';

// @ts-ignore
window.toJS = toJS;
